<script setup lang="ts">
import { ref, computed } from 'vue';
import axios from '@/api/axios';
// import { useRouter } from 'vue-router';
// import { useToast } from 'vue-toastification'; // if you use a toast lib

const props = defineProps<{ conversationUuid: string }>();
const emit = defineEmits(['sent']);

const text = ref('');
const attachment = ref<File | null>(null);
const sending = ref(false);

// const toast = useToast?.() || { success: () => {}, error: () => {} };

const canSend = computed(() => !!text.value || !!attachment.value);

async function send() {
	if (!canSend.value || sending.value) return;
	sending.value = true;
	try {
		const form = new FormData();
		form.append('type', 'text');
		form.append('message', text.value);
		if (attachment.value) form.append('attachment', attachment.value as Blob);

		const res = await axios.post(
			`/chat/conversations/${props.conversationUuid}/messages`,
			form,
			{
				headers: { 'Content-Type': 'multipart/form-data' },
			}
		);

		// emit created message
		emit('sent', res.data);
		text.value = '';
		attachment.value = null;
		// toast.success('Message sent');
		console.log('Message sent');
	} catch (e) {
		console.error(e);
		// toast.error('Failed to send');
		console.log('Failed to send');
	} finally {
		sending.value = false;
	}
}
</script>

<template>
	<div class="d-flex align-center" style="gap: 8px; width: 100%">
		<v-file-input
			v-model="attachment"
			icon="mdi-paperclip"
			accept="*/*"
			variant="plain"
		/>
		<v-text-field
			v-model="text"
			placeholder="Write a message..."
			dense
			@keyup.enter="send"
		/>
		<v-btn
			color="teal"
			@click="send"
			:loading="sending"
			:disabled="sending || !canSend"
		>
			<v-icon>mdi-send</v-icon>
		</v-btn>
	</div>
</template>
